import { nanoid } from 'nanoid/async'

import { updateNodeConnections } from '../../utils/functions'
import { userInputFlowSingleModal } from './userInputFlowSingleModal'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: userInputFlowSingleData } = await userInputFlowSingleModal(oldData, node)

  if (userInputFlowSingleData && Object.values(userInputFlowSingleData).length > 0) {
    // Create user input flow single unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, userInputFlowSingleData)

    node.update()
    updateNodeConnections(node)    
  }

  return false
}